export const toneOptions = [
  {
    value: 'warm',
    label: 'gpt-message-rewrite-tone-warm',
    key: 'gpt-message-rewrite-tone-warm'
  },
  // TODO: Remove this option later
  // {
  //   value: 'local',
  //   label: 'gpt-message-rewrite-tone-local',
  //   key: 'gpt-message-rewrite-tone-local'
  // },
  {
    value: 'professional',
    label: 'gpt-message-rewrite-tone-professional',
    key: 'gpt-message-rewrite-tone-professional'
  },
  {
    value: 'humble',
    label: 'gpt-message-rewrite-tone-humble',
    key: 'gpt-message-rewrite-tone-humble'
  },
  {
    value: 'sarcastic',
    label: 'gpt-message-rewrite-tone-sarcastic',
    key: 'gpt-message-rewrite-tone-sarcastic'
  }
];

export const dialetOptions = [
  {
    value: 'cantonese',
    label: 'gpt-message-rewrite-dialet-cantonese',
    key: 'gpt-message-rewrite-dialet-cantonese'
  },
  {
    value: 'putonghua',
    label: 'gpt-message-rewrite-dialet-putonghua',
    key: 'gpt-message-rewrite-dialet-putonghua'
  },
  {
    value: 'shshanghai',
    label: 'gpt-message-rewrite-dialet-shshanghai',
    key: 'gpt-message-rewrite-dialet-shshanghai'
  },
  {
    value: 'sichuan',
    label: 'gpt-message-rewrite-dialet-sichuan',
    key: 'gpt-message-rewrite-dialet-sichuan'
  },
  {
    value: 'beijing',
    label: 'gpt-message-rewrite-dialet-beijing',
    key: 'gpt-message-rewrite-dialet-beijing'
  },
  {
    value: 'minnan',
    label: 'gpt-message-rewrite-dialet-minnan',
    key: 'gpt-message-rewrite-dialet-minnan'
  },
  {
    value: 'hakka Chinese',
    label: 'gpt-message-rewrite-dialet-Hakka',
    key: 'gpt-message-rewrite-dialet-Hakka'
  },
  {
    value: 'english',
    label: 'gpt-message-rewrite-dialet-english',
    key: 'gpt-message-rewrite-dialet-english'
  },
  { value: 'japanese', 
    label: 'gpt-message-rewrite-dialet-japanese',
    key: 'gpt-message-rewrite-dialet-japanese'
   }

];

export const clientsLifeStageOptions = [
  {
    key: "career-start",
    value: "career-start",
    label: {
      zh: "事业起步",
      en: "Career Start",
      "zh-Hant-HK": "事業起步"
    }
  },
  {
    key: "family-growth",
    value: "family-growth",
    label: {
      zh: "成家立业",
      en: "Family Life",
      "zh-Hant-HK": "成家立室"
    }
  },
  {
    key: "pre-retirement",
    value: "pre-retirement",
    label: {
      zh: "准退休族",
      en: "Pre-Retirement",
      "zh-Hant-HK": "準退休族"
    }
  },
  {
    key: "retired",
    value: "retired",
    label: {
      zh: "退休养老",
      en: "Retired",
      "zh-Hant-HK": "退休養老"
    }
  }
];


export const DISCMapping = {
    D: { outgoing: true, introverted: false, logical: true, emotional: false },
    I: { outgoing: true, introverted: false, logical: false, emotional: true },
    S: { outgoing: false, introverted: true, logical: false, emotional: true },
    C: { outgoing: false, introverted: true, logical: true, emotional: false }
  };

export const genderOptions = [
  { value: 'Male', labelId: 'male' },
  { value: 'Female', labelId: 'female' }
];

export const financialTargetOptions = [
  { value: 'Entertainment Fund', labelId: 'entertainment-fund' },
  { value: 'Marriage', labelId: 'marriage' },
  { value: 'Property Purchase', labelId: 'property-purchase' },
  { value: 'Retired', labelId: 'retired' },
  { value: 'Continuing Education', labelId: 'continuing-education' },
  { value: 'Entrepreneurship', labelId: 'entrepreneurship' },
  { value: 'Children Education', labelId: 'children-education' }
];

export const financialInterestOptions = [
  { value: 'Life Insurance', labelId: 'life-insurance' },
  { value: 'Critical Illness', labelId: 'critical-illness' },
  { value: 'Mdeical', labelId: 'medical' },
  { value: 'Savings', labelId: 'savings' }
];

export const hobbiesOptions = [
  { value: 'Pets', labelId: 'pets' },
  { value: 'Arts', labelId: 'arts' },
  { value: 'Sports', labelId: 'sports' },
  { value: 'Media', labelId: 'media' },
  { value: 'Travel', labelId: 'travel' }
];

export const chatPurposeOptions = [
  { value: 'Keep Connection', labelId: 'keep-connection' },
  { value: 'Product Selling', labelId: 'product-selling' },
  { value: 'Instill concepts', labelId: 'instill-concepts' }
];

export const languageOptions = [
  { value: 'Traditional Chinese', labelId: 'traditional-chinese' },
  { value: 'English', labelId: 'standard-english' },
  { value: 'Simplified Chinese', labelId: 'simplified-chinese' }
];

export const personalAnalysisLifeStageOptions = [
  { value: 'Career Start', labelId: 'career-start' },
  { value: 'Career & Family Growth', labelId: 'career-and-family-growth' },
  { value: 'Striving for career success', labelId: 'striving-for-career-success' },
  { value: 'Family with Children', labelId: 'family-with-children' },
  { value: 'Retired', labelId: 'retired' }
];